(() => {
  const root = document.getElementById("howl-audio-root");
  if (!root) return;

  const iframe = document.getElementById("howl-soundcloud-iframe");
  const fab = document.getElementById("howl-audio-fab");
  const closeBtn = document.getElementById("howl-audio-close");

  const titleEl = root.querySelector(".howl-audio-panel__title");
  const subtitleEl = root.querySelector(".howl-audio-panel__eyebrow");

  const mainSelector = root.dataset.mainSelector || "#MainContent";

  const storageKeyState = "howl_audio_ui_state";
  const storageKeyDismissed = "howl_audio_dismissed";
  const storageKeyPosition = "howl_audio_position";
  const storageKeyPlaying = "howl_audio_is_playing";
  const storageKeySeen = "howl_audio_seen";
  const storageKeyCurrentUrl = "howl_current_url";
  const storageKeyCurrentTitle = "howl_current_title";
  const storageKeyCurrentSubtitle = "howl_current_subtitle";
  const storageKeyResume = "howl_audio_resume";

  let widget = null;
  let isBooted = false;

let shouldDelayMinimize = false;
let minimizeTimeout = null;

  function getUiState() {
    return localStorage.getItem(storageKeyDismissed) === "1"
      ? "dismissed"
      : localStorage.getItem(storageKeyState) || "expanded";
  }

  function applyUiState(state) {
    root.classList.remove("is-expanded", "is-minimized", "is-dismissed");
    root.classList.add(`is-${state}`);
  }

  function setExpanded() {
    localStorage.removeItem(storageKeyDismissed);
    localStorage.setItem(storageKeyState, "expanded");
    applyUiState("expanded");
  }

  function setMinimized() {
    localStorage.removeItem(storageKeyDismissed);
    localStorage.setItem(storageKeyState, "minimized");
    applyUiState("minimized");
  }

  function setDismissed() {
    localStorage.setItem(storageKeyDismissed, "1");
    applyUiState("dismissed");
  }

  function buildSoundCloudSrc(url, autoplay = false) {
    return `https://w.soundcloud.com/player/?url=${encodeURIComponent(
      url
    )}&color=%23000000&auto_play=${autoplay}&show_artwork=false&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&visual=false`;
  }

  function updatePanelText(title, subtitle) {
    if (titleEl && title) {
      titleEl.textContent = title;
    }

    if (subtitleEl && subtitle) {
      subtitleEl.textContent = subtitle;
    }
  }

  function saveCurrentMix(url, title, subtitle) {
    localStorage.setItem(storageKeyCurrentUrl, url || "");
    localStorage.setItem(storageKeyCurrentTitle, title || "");
    localStorage.setItem(storageKeyCurrentSubtitle, subtitle || "");
  }

  function bootWidget() {
    if (isBooted || !window.SC || !iframe) return;
    isBooted = true;

    widget = window.SC.Widget(iframe);

    widget.bind(window.SC.Widget.Events.READY, () => {
      const savedPosition = Number(localStorage.getItem(storageKeyPosition) || 0);
      const shouldResume = localStorage.getItem(storageKeyResume) === "1";

      if (savedPosition > 0) {
        widget.seekTo(savedPosition);
      }

      if (shouldResume) {
        widget.play();
      }
    });

widget.bind(window.SC.Widget.Events.PLAY, () => {
  localStorage.setItem(storageKeyPlaying, "1");
  localStorage.setItem(storageKeyResume, "1");
  setPlayingUi(true);

  if (minimizeTimeout) {
    clearTimeout(minimizeTimeout);
    minimizeTimeout = null;
  }

  if (shouldDelayMinimize) {
    minimizeTimeout = window.setTimeout(() => {
      setMinimized();
      shouldDelayMinimize = false;
      minimizeTimeout = null;
    }, 3000);
  } else {
    setMinimized();
  }
});

   widget.bind(window.SC.Widget.Events.PAUSE, () => {
  localStorage.setItem(storageKeyPlaying, "0");
  localStorage.removeItem(storageKeyResume);
  setPlayingUi(false);
});

    widget.bind(window.SC.Widget.Events.PLAY_PROGRESS, (e) => {
      localStorage.setItem(
        storageKeyPosition,
        String(Math.floor(e.currentPosition || 0))
      );
    });
  }

  function loadMix({ url, title, subtitle }) {
  if (!iframe || !url) return;

  if (minimizeTimeout) {
    clearTimeout(minimizeTimeout);
    minimizeTimeout = null;
  }

  iframe.src = buildSoundCloudSrc(url, true);
  updatePanelText(title, subtitle);
  saveCurrentMix(url, title, subtitle);

  localStorage.setItem(storageKeyPosition, "0");
  localStorage.setItem(storageKeyPlaying, "1");
  localStorage.setItem(storageKeyResume, "1");

  isBooted = false;
  bootWidget();

  // Open immediately when a new mix is loaded
  localStorage.removeItem(storageKeyDismissed);
  localStorage.setItem(storageKeyState, "expanded");
  applyUiState("expanded");

  // But don't minimize instantly on first PLAY event; wait a moment
  shouldDelayMinimize = true;
}
  
function setPlayingUi(isPlaying) {
  root.classList.toggle("is-playing", isPlaying);
}


 function shouldHijackLink(link, event) {
  if (!link) return false;
  if (event.defaultPrevented) return false;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
  if (link.target && link.target !== "_self") return false;
  if (link.hasAttribute("download")) return false;

  // Let theme-controlled UI work normally
  if (
    link.closest('details') ||
    link.closest('summary') ||
    link.closest('dialog') ||
    link.closest('[aria-modal="true"]') ||
    link.closest('.menu-drawer') ||
    link.closest('.drawer') ||
    link.closest('.header-drawer') ||
    link.closest('.mobile-menu') ||
    link.closest('.predictive-search') ||
    link.closest('.cart-drawer')
  ) {
    return false;
  }

  const href = link.getAttribute("href");
  if (!href || href.startsWith("#")) return false;

  const url = new URL(link.href, window.location.origin);
  if (url.origin !== window.location.origin) return false;

  const skipPrefixes = ["/cart", "/checkout", "/account", "/search"];
  if (skipPrefixes.some((prefix) => url.pathname.startsWith(prefix))) return false;

  return true;
}

  async function fetchAndSwap(url, push = true) {
    const res = await fetch(url, {
      headers: { "X-Requested-With": "XMLHttpRequest" },
      credentials: "same-origin"
    });

    if (!res.ok) {
      window.location.href = url;
      return;
    }

    const html = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const nextMain = doc.querySelector(mainSelector) || doc.querySelector("main");
    const currentMain = document.querySelector(mainSelector) || document.querySelector("main");

    if (!nextMain || !currentMain) {
      window.location.href = url;
      return;
    }

    currentMain.innerHTML = nextMain.innerHTML;
    document.title = doc.title;
    document.body.className = doc.body.className;

    const nextCanonical = doc.querySelector('link[rel="canonical"]');
    let currentCanonical = document.querySelector('link[rel="canonical"]');

    if (nextCanonical) {
      if (!currentCanonical) {
        currentCanonical = document.createElement("link");
        currentCanonical.setAttribute("rel", "canonical");
        document.head.appendChild(currentCanonical);
      }
      currentCanonical.setAttribute("href", nextCanonical.getAttribute("href"));
    }

reinitializeDynamicApps(currentMain);

    if (push) {
      history.pushState({}, "", url);
    }

    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.dispatchEvent(
      new CustomEvent("howl:navigation-complete", { detail: { url } })
    );
  }

  function reinitializeDynamicApps(scope) {
  const scripts = scope.querySelectorAll("script");

  scripts.forEach((oldScript) => {
    const newScript = document.createElement("script");

    [...oldScript.attributes].forEach((attr) => {
      newScript.setAttribute(attr.name, attr.value);
    });

    newScript.textContent = oldScript.textContent;
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });

  document.dispatchEvent(new CustomEvent("theme:page:changed"));
  document.dispatchEvent(new CustomEvent("shopify:section:load"));
  window.dispatchEvent(new Event("resize"));

  requestAnimationFrame(() => {
    window.dispatchEvent(new Event("scroll"));
  });
}

  document.addEventListener("click", (event) => {
    const mixBtn = event.target.closest(".howl-load-mix");
    if (!mixBtn) return;

    event.preventDefault();
    event.stopPropagation();

    loadMix({
      url: mixBtn.dataset.url,
      title: mixBtn.dataset.title,
      subtitle: mixBtn.dataset.subtitle
    });
  });

  document.addEventListener("click", (event) => {
    const link = event.target.closest("a");
    if (!shouldHijackLink(link, event)) return;

    event.preventDefault();

    fetchAndSwap(link.href).catch(() => {
      window.location.href = link.href;
    });
  });

  window.addEventListener("popstate", () => {
    fetchAndSwap(window.location.href, false).catch(() => {
      window.location.reload();
    });
  });

  fab?.addEventListener("click", setExpanded);
  closeBtn?.addEventListener("click", setDismissed);

  const savedUrl = localStorage.getItem(storageKeyCurrentUrl);
  const savedTitle = localStorage.getItem(storageKeyCurrentTitle);
  const savedSubtitle = localStorage.getItem(storageKeyCurrentSubtitle);

  if (savedUrl && iframe) {
    iframe.src = buildSoundCloudSrc(savedUrl, false);
    updatePanelText(savedTitle, savedSubtitle);
  }

const hasSeen = localStorage.getItem(storageKeySeen) === "1";
const isPlaying = localStorage.getItem(storageKeyPlaying) === "1";
setPlayingUi(isPlaying);

if (!hasSeen) {
  localStorage.setItem(storageKeySeen, "1");

  // Only open the player first time if something is actually playing
  if (isPlaying) {
    applyUiState("expanded");
  } else {
    applyUiState("minimized");
  }

} else {

  // Restore UI state only if music is playing
  if (isPlaying) {
    applyUiState(getUiState());
  } else {
    applyUiState("minimized");
  }

}

root.classList.remove("is-initializing");

  if (window.SC && iframe) {
    bootWidget();
  } else {
    window.addEventListener("load", () => {
      if (window.SC && iframe) bootWidget();
    });
  }
})();